import React, { memo } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function InvoiceIcon({ dark = false, ...props }: Props) {
  const { palette }: Theme = useTheme();

  const contrastForeground = dark ? palette.secondary.lightest : palette.primary.main;

  const foreground = contrastForeground;

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill={foreground}
        d="M8.93 16.39h5.38a.74.74 0 000-1.49H8.93c-.41 0-.75.33-.75.74s.34.75.75.75zm3.34-6.49H8.93c-.41 0-.75.34-.75.75s.34.74.75.74h3.34a.74.74 0 000-1.49zm7.07-.87l.71-.01c.25 0 .45.2.45.45v8.04A4.47 4.47 0 0116.05 22H8.17a4.7 4.7 0 01-4.67-4.71V6.51C3.5 4.03 5.5 2 7.97 2h5.28c.26 0 .46.21.46.46v3.22c0 1.83 1.5 3.33 3.3 3.34a127.56 127.56 0 011.8.01h.53zm.27-1.46l-2.46-.01c-1.1 0-2-.91-2-2.02V2.91c0-.44.52-.65.81-.34l2.01 2.1 1.98 2.09c.29.3.08.8-.34.8z"
      />
    </SvgIcon>
  );
}

export default memo(InvoiceIcon);
